import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Menu, MenuItem, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Logo from '../media/logoempresa.png'
import { useLocation, useNavigate } from 'react-router-dom';
import { CerrarSesion } from './CerrarSesion';
import { getAlmacenes, getSession, patchMiPassword } from '../services/apis';
import { normalizarArray } from '../utils/apiResponse';
import { getAlmacenSeleccionado, setAlmacenSeleccionado } from '../utils/almacenSeleccionado';
import { APP_DATA } from '../data';
import { getUsuarioFromSession, puedeVerAjustes } from '../utils/permisos';
import Swal from 'sweetalert2';


import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DisplaySettingsIcon from '@mui/icons-material/DisplaySettings';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
export const Header = () => {

    const Navigate = useNavigate();
    const location = useLocation();

    const [almacenes, setAlmacenes] = useState([]);
    const [value, setValue] = useState(() => getAlmacenSeleccionado());
    const [loadingAlmacenes, setLoadingAlmacenes] = useState(true);
    const [loadingUsuario, setLoadingUsuario] = useState(true);
    const [usuarioSesion, setUsuarioSesion] = useState(null);
    const [openMiPassword, setOpenMiPassword] = useState(false);
    const [perfilAnchorEl, setPerfilAnchorEl] = useState(null);
    const [miPasswordForm, setMiPasswordForm] = useState({
        passwordActual: '',
        nuevaPassword: '',
    });

    const opcionesHeaderBase = [
        {
            nombre: "Planificador",
            ruta: "/pedidos",
            icon: 'CalendarMonthIcon'
        },
        {
            nombre: "Ajustes",
            ruta: "/ajustes",
            icon: 'DisplaySettingsIcon'
        },
        {
            nombre: "Guía",
            ruta: "/guia",
            icon: 'HelpOutlineIcon'
        }
    ]

    const getNombreUsuario = (usuario) => (
        usuario?.nombreUsuario
        || usuario?.nombreCompleto
        || usuario?.nombreReal
        || usuario?.fullName
        || usuario?.displayName
        || usuario?.persona?.nombreCompleto
        || usuario?.persona?.nombre
        || usuario?.nombre
        || usuario?.name
        || usuario?.usuario
        || usuario?.username
        || usuario?.email
        || usuario?.correo
        || ''
    )

    const getIcon = (icon, active = false, compact = false) => {
        const iconSx = { fontSize: compact ? 20 : 18 };
        const icons = {
            CalendarMonthIcon: <CalendarMonthIcon sx={iconSx} />,
            DisplaySettingsIcon: <DisplaySettingsIcon sx={iconSx} />,
            HelpOutlineIcon: <HelpOutlineRoundedIcon sx={iconSx} />,
        };

        return React.cloneElement(icons[icon], {
            sx: {
                ...iconSx,
                color: active ? 'primary.contrastText' : 'primary.main',
            },
        });
    }

    const getNavButtonSx = (active, compact = false) => ({
        minHeight: compact ? 32 : 30,
        minWidth: active && !compact ? 132 : 'auto',
        px: active ? (compact ? 1.3 : 1.9) : (compact ? 0.8 : 1.2),
        py: 0.3,
        borderRadius: '6px',
        color: active ? 'primary.contrastText' : 'var(--negro)',
        fontSize: compact ? '0.75rem' : '0.78rem',
        fontWeight: 700,
        lineHeight: 1,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        boxShadow: active ? '0 2px 5px rgba(245, 124, 0, 0.24)' : 'none',
        '& .MuiButton-startIcon': {
            mr: compact ? 0 : 0.45,
            ml: 0,
            color: 'inherit',
        },
        '&:hover': {
            boxShadow: active ? '0 2px 5px rgba(245, 124, 0, 0.24)' : 'none',
        },
    })

    function handleChange(codAlmacen) {
        setValue(codAlmacen);
        setAlmacenSeleccionado(codAlmacen);
    }

    const isRutaActiva = (ruta) => (
        location.pathname === ruta || (ruta === '/pedidos' && location.pathname === '/')
    )

    const mostrarFiltroAlmacenes = isRutaActiva('/pedidos')

    useEffect(() => {
        const cargarAlmacenesHeader = async () => {
            setLoadingAlmacenes(true);

            try {
                const almacenesResponse = await getAlmacenes();
                const response = almacenesResponse;
                const almacenesData = normalizarArray(response, 'almacenes');

                setAlmacenes(almacenesData);
                setValue((almacenActual) => {
                    const almacenGuardado = getAlmacenSeleccionado();
                    const almacenDisponible = almacenesData.some((almacen) => String(almacen.codAlmacen) === String(almacenGuardado));
                    const siguienteAlmacen = almacenDisponible
                        ? almacenGuardado
                        : (almacenActual || almacenesData[0]?.codAlmacen || '');

                    if (siguienteAlmacen) setAlmacenSeleccionado(siguienteAlmacen);

                    return siguienteAlmacen;
                });
            } catch (error) {
                console.error('Error al cargar almacenes del header:', error);
                setAlmacenes([]);
                setValue('');
            } finally {
                setLoadingAlmacenes(false);
            }
        };

        const cargarUsuarioHeader = async () => {
            setLoadingUsuario(true);

            try {
                const sessionResponse = await getSession();
                setUsuarioSesion(getUsuarioFromSession(sessionResponse));
            } catch (error) {
                console.error('Error al cargar usuario del header:', error);
                setUsuarioSesion(null);
            } finally {
                setLoadingUsuario(false);
            }
        };

        cargarAlmacenesHeader();
        cargarUsuarioHeader();
    }, []);

    const usuarioActual = getUsuarioFromSession(usuarioSesion);
    const opcionesHeader = opcionesHeaderBase.filter((opcion) => (
        opcion.ruta !== '/ajustes' || puedeVerAjustes(usuarioActual)
    ))
    const nombreUsuario = getNombreUsuario(usuarioActual);
    const usuarioHeader = loadingUsuario ? '' : (nombreUsuario || 'Usuario');
    const inicialesUsuario = usuarioHeader
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((parte) => parte[0]?.toUpperCase())
        .join('') || 'U';

    const cerrarMiPassword = () => {
        setOpenMiPassword(false);
        setMiPasswordForm({ passwordActual: '', nuevaPassword: '' });
    }

    const abrirMenuPerfil = (event) => {
        setPerfilAnchorEl(event.currentTarget);
    }

    const cerrarMenuPerfil = () => {
        setPerfilAnchorEl(null);
    }

    const abrirCambioPassword = () => {
        cerrarMenuPerfil();
        setOpenMiPassword(true);
    }

    const guardarMiPassword = async (event) => {
        event.preventDefault();

        try {
            await patchMiPassword(miPasswordForm);
            cerrarMiPassword();
            Swal.fire({
                icon: 'success',
                title: 'Contraseña actualizada',
                showConfirmButton: false,
                timer: 1500,
            });
        } catch (error) {
            const message = Array.isArray(error.response?.data?.message)
                ? error.response.data.message.join('\n')
                : (error.response?.data?.message || 'Error al cambiar tu contraseña');

            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
                timer: 2500,
                showConfirmButton: false,
            });
        }
    }

    return (
        <Grid
            container
            direction="row"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "space-between",
                alignItems: "center",
            }}
            className='header'
            spacing={{ xs: 2, md: 0 }}
        >
            <Grid
                container
                direction="row"
                size={{ xs: 12, sm: 7, md: 7, xl: 7 }}
                sx={{
                    justifyContent: "start",
                    alignItems: "center",
                    flexWrap: 'nowrap',
                }}
                spacing={0.8}
            >
                <Grid
                    container
                    direction="row"
                    size="auto"
                    sx={{
                        justifyContent: "start",
                        alignItems: "center",
                        cursor: 'pointer',
                        flexWrap: 'nowrap',
                        flexShrink: 0,
                    }}
                    className='no-select pointer'
                    onClick={() => Navigate("/")}
                >
                    <img src={Logo} alt="" style={{ width: 34, minWidth: 34 }} />
                    <Typography
                        variant="body2"
                        sx={{
                            ml: 0.8,
                            display: { xs: 'none', md: 'block' },
                            color: 'var(--negro)',
                            fontWeight: 800,
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {APP_DATA.empresaNombre}
                    </Typography>
                </Grid>

                {mostrarFiltroAlmacenes && (
                    <Grid
                        container
                        direction="row"
                        size="grow"
                        sx={{
                            display: { xs: 'none', sm: 'flex' },
                            justifyContent: "start",
                            alignItems: "center",
                            flexWrap: "nowrap",
                            gap: 0.75,
                            overflowX: 'auto',
                            minWidth: 0,
                        }}
                    >
                        {loadingAlmacenes && (
                            <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                Cargando centros...
                            </Typography>
                        )}

                        {!loadingAlmacenes && almacenes.length === 0 && (
                            <Typography variant="body2" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
                                Sin centros
                            </Typography>
                        )}

                        {!loadingAlmacenes && almacenes.map((almacen) => {
                            const active = String(value) === String(almacen.codAlmacen)

                            return (
                                <Button
                                    key={almacen.codAlmacen}
                                    variant={active ? "contained" : "text"}
                                    size="small"
                                    onClick={() => handleChange(almacen.codAlmacen)}
                                    sx={{
                                        minHeight: 30,
                                        px: active ? 1.35 : 1,
                                        py: active ? 0.55 : 0.35,
                                        borderRadius: '6px',
                                        color: active ? 'primary.contrastText' : 'var(--negro)',
                                        fontSize: '0.78rem',
                                        fontWeight: 700,
                                        lineHeight: 1,
                                        textTransform: 'none',
                                        whiteSpace: 'nowrap',
                                        boxShadow: active ? '0 2px 5px rgba(245, 124, 0, 0.24)' : 'none',
                                        '&:hover': {
                                            boxShadow: active ? '0 2px 5px rgba(245, 124, 0, 0.24)' : 'none',
                                        },
                                    }}
                                >
                                    {almacen.desAlmacen}
                                </Button>
                            )
                        })}
                    </Grid>
                )}


                <Grid
                    container
                    direction="row"
                    size={{ xs: 10, sm: 12, md: 10, xl: 5 }}
                    sx={{
                        justifyContent: { xs: 'center', sm: 'end' },
                        alignItems: "center",
                        display: { xs: 'flex', sm: 'none' }
                    }}
                    spacing={{ xs: 0, md: 2 }}
                >
                    {opcionesHeader.map((info, index) => (
                        <Grid key={info.ruta} item size={{ xs: 3, md: 2, xl: 2 }}>
                            <Button
                                variant={isRutaActiva(info.ruta) ? "contained" : "text"}
                                onClick={() => Navigate(info.ruta)}
                                startIcon={getIcon(info.icon, isRutaActiva(info.ruta), true)}
                                sx={getNavButtonSx(isRutaActiva(info.ruta), true)}
                                fullWidth
                            />

                        </Grid>
                    ))}
                    <Grid item size={{ xs: 2, md: 1.5 }}>
                        <Avatar
                            onClick={abrirMenuPerfil}
                            sx={{ width: 28, height: 28, bgcolor: '#FFF1D6', color: '#B45309', fontSize: '0.76rem', fontWeight: 800, cursor: 'pointer' }}
                        >
                            {inicialesUsuario}
                        </Avatar>
                    </Grid>
                    <Grid item size={{ xs: 0, md: 1.5 }}>
                        <CerrarSesion />
                    </Grid>

                </Grid>



            </Grid>



            <Grid
                container
                direction="row"
                size={{ xs: 12, sm: 5, md: 5, xl: 5 }}
                sx={{
                    justifyContent: { xs: 'center', md: 'end' },
                    alignItems: "center",
                    display: { xs: 'none', sm: 'flex' }
                }}
                spacing={{ xs: 0, md: 1.4 }}
            >
                {opcionesHeader.map((info, index) => (
                    <Grid key={info.ruta} item size="auto" sx={{ flexShrink: 0 }}>
                        <Button
                            variant={isRutaActiva(info.ruta) ? "contained" : "text"}
                            size="small"
                            onClick={() => Navigate(info.ruta)}
                            startIcon={getIcon(info.icon, isRutaActiva(info.ruta))}
                            sx={getNavButtonSx(isRutaActiva(info.ruta))}
                        >
                            {info.nombre}
                        </Button>

                    </Grid>
                ))}
                <Grid item size={{ xs: 0, md: 2.3 }}>
                    <Grid container direction="row" sx={{ justifyContent: "center", alignItems: "center", gap: 1 }}>
                        <Avatar
                            onClick={abrirMenuPerfil}
                            sx={{ width: 28, height: 28, bgcolor: '#FFF1D6', color: '#B45309', fontSize: '0.76rem', fontWeight: 800, cursor: 'pointer' }}
                        >
                            {inicialesUsuario}
                        </Avatar>

                        <Typography
                            variant="body2"
                            onClick={abrirMenuPerfil}
                            sx={{ color: 'var(--negro)', whiteSpace: 'nowrap', cursor: 'pointer' }}
                        >
                            {usuarioHeader}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item size={{ xs: 0, md: 1 }}>
                    <CerrarSesion />
                </Grid>

            </Grid>

            <Menu
                anchorEl={perfilAnchorEl}
                open={Boolean(perfilAnchorEl)}
                onClose={cerrarMenuPerfil}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem onClick={abrirCambioPassword}>
                    Cambiar mi contraseña
                </MenuItem>
            </Menu>

            <Dialog open={openMiPassword} onClose={cerrarMiPassword} fullWidth maxWidth="xs">
                <form onSubmit={guardarMiPassword}>
                    <DialogTitle>
                        Cambiar mi contraseña
                    </DialogTitle>

                    <DialogContent sx={{ display: 'grid', gap: 2, pt: 1 }}>
                        <TextField
                            label="Contraseña actual"
                            type="password"
                            value={miPasswordForm.passwordActual}
                            onChange={(event) => setMiPasswordForm((form) => ({ ...form, passwordActual: event.target.value }))}
                            fullWidth
                            required
                        />
                        <TextField
                            label="Nueva contraseña"
                            type="password"
                            value={miPasswordForm.nuevaPassword}
                            onChange={(event) => setMiPasswordForm((form) => ({ ...form, nuevaPassword: event.target.value }))}
                            fullWidth
                            required
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={cerrarMiPassword}>
                            Cancelar
                        </Button>
                        <Button variant="contained" type="submit">
                            Guardar contraseña
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid >
    )
}
